import TextCreate from 'core/display/simple/Text'
import { AutoSpinManager } from 'managers/AutoSpinManager'
import { signal } from 'services/SignalsService'

export default class AutoCountText extends TextCreate {
  constructor(data) {
    super(data)

    signal.on('MODEL:AUTO', (value) => {
      this.update(value)
    })

    signal.on('STATE:IN:AUTO', () => {
      this.update(AutoSpinManager.count())
    })

    signal.on('RADIO:ui|automenu', () => {
      this.update(game.models.AutoCountModel.getValue())
    })
  }
}
